import { api } from '../services/api';

/** Registra una descarga explícita; no bloquea la entrega del archivo si falla. */
export function recordOperationsDownload({ fileType, moduleKey, reportName }) {
  const payload = {
    file_type: fileType,
    module_key: moduleKey,
    report_name: reportName,
  };
  return api.admin.operationsLog.recordDownload(payload).catch(() => {});
}

export default recordOperationsDownload;
